import { NgZone } from "@angular/core";
import { DialogCloseReason, IDialogOnClose } from "../../../../lib/dialogs/base-dialog";
import { DialogService } from "../../../../lib/dialogs/dialog.service";
import { IWebPageOpenGraphData } from "../../../ck-editor-fetch-web-page-content-plugin";
import { TranslateService } from "@ngx-translate/core";
import { FetchWebPageContentDialogComponent } from "../../fetch-web-page-content-dialog.component";
import { Editor, ICommandDefinition, IScaledDimensions } from "./cd-fetch-web-content-command.model";

export class CDFetchWebContentCommand implements ICommandDefinition {
  public readMoreLinkCaption: string;
  private editor: Editor;

  constructor(
    private dialogService: DialogService,
    private translate: TranslateService,
    private zone: NgZone
  ) {
    this.readMoreLinkCaption = this.translate.instant('COMMON.DIALOGS.FETCH_WEB_PAGE_CONTENT.READ_MORE');
  }

  public exec = (editor: Editor): boolean =>  {
    this.editor = editor;

    const selection = editor.getSelection();
    const rangeOfSelectionBeforeDialog = selection.getRanges()[0];
    editor.focusManager.lock();

    this.zone.run(() => {
      this.dialogService.createDialog(FetchWebPageContentDialogComponent)
        .onClose.subscribe(({ reason, data }: IDialogOnClose = {}) => {
          if (reason === DialogCloseReason.OK) {
            this.insertElementsFromOpenGraph({ ...data.webPageContentData }, (window as any).selectedBlock.width)
          } else {
            rangeOfSelectionBeforeDialog.select();
          }
          editor.focusManager.unlock();
          editor.focus();
        });
    });
    return true;
  }

  private insertElementsFromOpenGraph = ({ Title, ImageUrl, Description, Link, ImageHeight, ImageWidth }: IWebPageOpenGraphData, maxWidth: string, insertImage = (document.getElementById("image-checkbox-id") as HTMLInputElement).checked) => {
    const targetWidth = +`${maxWidth}`.replace(/[a-zA-Z]+/g, '');
    this.whenAvailable(Title, () => this.insert(`<h5>${Title}</h5>`));
      if (insertImage) {
        this.whenAvailable(ImageUrl || Description, () => this.insert(`<p><br></p>`));
        this.whenAvailable(ImageUrl, () => {
          const { width, height } = this.scaleDimensions(ImageHeight, ImageWidth, targetWidth);
          this.insert(`<img class="ck-editor-embedded-image" src="${ImageUrl}" width="${width}" height="${height}" style="height:auto;width:100%;">`);
        });
      }
    this.whenAvailable(Description, () => this.insert(`<p>${Description}</p>`));
    this.whenAvailable(Link, () => {
      this.insert(`<p><br></p>`);
      this.insert(`<p><a href="${Link}" target="_blank">${this.readMoreLinkCaption}</a></p>`);
    });
  }

  private whenAvailable = (value: unknown, callback: () => void): void => (value && callback());

  private insert = (htmlString: string): void => {
    this.editor.insertElement(CKEDITOR.dom.element.createFromHtml(htmlString));
  }

  private scaleDimensions = (imageHeight: number, imageWidth: number, targetWidth = 536 /*Max layout width - padding*/): IScaledDimensions => {
    targetWidth = targetWidth > 536 ? 536: targetWidth;
    let width = imageWidth, height = imageHeight, ratio;

    ratio = targetWidth / width;
    height = Math.round(height * ratio);
    width = Math.round(width * ratio);

    return { width, height };
  }
}
